import React, { createContext, useReducer, useContext } from "react";

const StateCtx = createContext();
const DispatchCtx = createContext();

const initialState = {
  selectedOptionId: null,
  amount: null,
  donor: { name: "", email: "", phone: "", pan: "", address: "", pin: "" },
  lastOrder: null
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_SELECTION":
      return {
        ...state,
        selectedOptionId: action.payload.id ?? state.selectedOptionId,
        amount: action.payload.amount ?? state.amount
      };
    case "SET_AMOUNT":
      return { ...state, amount: action.payload };
    case "SET_DONOR":
      return { ...state, donor: { ...state.donor, ...action.payload } };
    case "SET_LAST_ORDER":
      return { ...state, lastOrder: action.payload };
    case "RESET":
      return initialState;
    default:
      throw new Error("Unknown action: " + action.type);
  }
}

export function DonationProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <StateCtx.Provider value={state}>
      <DispatchCtx.Provider value={dispatch}>{children}</DispatchCtx.Provider>
    </StateCtx.Provider>
  );
}

export function useDonationState() {
  return useContext(StateCtx);
}
export function useDonationDispatch() {
  return useContext(DispatchCtx);
}
